import { render, staticRenderFns } from "./SearchView.vue?vue&type=template&id=0a4933a7&"
import script from "./SearchView.vue?vue&type=script&lang=ts&"
export * from "./SearchView.vue?vue&type=script&lang=ts&"
import style0 from "./SearchView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a4933a7')) {
      api.createRecord('0a4933a7', component.options)
    } else {
      api.reload('0a4933a7', component.options)
    }
    module.hot.accept("./SearchView.vue?vue&type=template&id=0a4933a7&", function () {
      api.rerender('0a4933a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SearchView.vue"
export default component.exports